import {sort, filter} from "./modules/collection.js";

// Collection
if (document.querySelector('#collection')) {
	sort();
	filter();
}
